import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../lib/content";

const VerticalCard = ({ index, name, sub, desc, image, link, cta, tone }) => (
  <Reveal delay={index * 0.1} className="group relative overflow-hidden border border-white/10 bg-midnight">
    <div className="relative h-64 overflow-hidden">
      <img src={image} alt={name} className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700" />
      <div className="absolute inset-0 bg-gradient-to-t from-midnight via-midnight/40 to-transparent" />
      <span className="absolute top-5 left-6 text-xs uppercase tracking-[0.25em] text-gold">{tone}</span>
    </div>
    <div className="p-8 lg:p-10">
      <h3 className="font-serif text-3xl lg:text-4xl font-light text-ivory">{name}</h3>
      <p className="mt-2 text-gold text-sm uppercase tracking-[0.15em]">{sub}</p>
      <p className="mt-5 text-ivory/60 leading-relaxed">{desc}</p>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`vertical-cta-${index}`}
        className="mt-8 inline-flex items-center gap-2 text-ivory font-medium border-b border-transparent hover:border-gold hover:text-gold transition-colors pb-1"
      >
        {cta}
        <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </a>
    </div>
  </Reveal>
);

export const BusinessVerticals = () => (
  <section id="businesses" data-testid="business-verticals" className="relative bg-navy py-24 lg:py-32 noise-overlay">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal className="max-w-3xl">
        <Overline>Chapter 02 — Our Businesses</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ivory">
          Two verticals. One connected vision.
        </h2>
        <p className="mt-6 text-lg text-ivory/60 leading-relaxed">
          KRV Nexus builds and connects distinct businesses — each with its own identity, unified by a shared commitment to structured growth and enduring value.
        </p>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-2 gap-8">
        <VerticalCard
          index={0}
          tone="Retail Ecosystem"
          name="KRVMart"
          sub="Everything for Everyday Living."
          desc="KRVMart is our modern multi-category retail concept designed to bring everyday essentials, fashion, furniture, and technology together under one organized retail experience."
          image={IMAGES.retail}
          link="https://www.krvmart.com"
          cta="Explore KRVMart"
        />
        <VerticalCard
          index={1}
          tone="Education & Research"
          name="KRV FinMart"
          sub="Structured Market Education & Research"
          desc="KRV FinMart is our financial market education and research platform focused on structured learning, systematic market analysis, disciplined trading frameworks, and research-driven insights."
          image={IMAGES.finance}
          link="https://www.krvfinmart.com"
          cta="Explore KRV FinMart"
        />
      </div>
    </div>
  </section>
);
